import { Component, OnInit } from '@angular/core';
import { SDIInvoiceStateCountersDTO } from '../../models/invoicestatecounters.model';
import { ConfigColumn, ExportEqpTable, TooltipPositionType, TypeColumn, EqpTableComponent, NumberColumnPipe, CellAlignmentEnum, CustomExportType } from '@eqproject/eqp-table';
import { TranslateService } from '@ngx-translate/core';
import { UtilityService } from '../../services/utility.service';
import { PortaleFEService } from '../../services/portaleFE.service';
import { CompanyService } from '../../services/company.service';
import { SDIService } from '../../services/sdi.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { GlobalService } from '../../services/global.service';
import { SDIResponseObject } from '../../models/helper.model';
import { DialogService } from '../../services/dialog.service';
import { CompanyListDTO, CompanyTypeEnum } from '../../models/company.model';
import { UserDTO } from '../../models/user.model';
import { FileTypeEnum, ImportExportDTO } from '../../models/importExport.model';
import { ImportExportService } from '../../services/import-export.service';
import { Company } from '../../models/datiAggiuntivi.model';

@Component({
  selector: 'app-invoice-counter',
  templateUrl: './invoice-counter.component.html',
  styleUrls: ['./invoice-counter.component.scss']
})
export class InvoiceCounterComponent implements OnInit {
    
  invoiceCounters: Array<SDIInvoiceStateCountersDTO> = new Array<SDIInvoiceStateCountersDTO>();
  columns: Array<ConfigColumn>;  
  sdiResponse: SDIResponseObject = new SDIResponseObject();
  currentCompany: CompanyListDTO;
  currentUser: UserDTO;  
  datastart: Date ;
  dataend: Date ;
  totalefattureattive: number;
  totalefatturepassive: number;  
  totalefatture: number;  
  packagequantity: number;
  countersExportDTO: ImportExportDTO = new ImportExportDTO();
  countersExport: ExportEqpTable = { buttonText: this.translate.instant("GENERIC_LABEL.EXPORT_MASK"), exportFileType: CustomExportType.XLSX, buttonIcon: "download", tooltipText: "Esporta", exportFileName: "Contatore fatture" };

  constructor(private router: Router,
    public translate: TranslateService,        
    private sdiService: SDIService,                    
    private authService: AuthService,
    private companyService: CompanyService,    
    private portaleFEService: PortaleFEService,                
    private utilService: UtilityService,
    private importExportService: ImportExportService) {
  }

  async ngOnInit() {
    this.getUrlPortaleFe();
    this.configureColumns();    
    this.currentCompany = GlobalService.getCurrentCompany();    
    this.currentUser = this.authService.getCurrentUser();
    
    this.countersExportDTO = this.initImportExportDTO("countersInvoice");
    
    //La funzione custom è stata inserita nell'on init perchè i DTO dovevano essere prima inizializzati
    this.countersExport.customExportFunction = [this.customExportFunction(this.countersExportDTO)];    

    this.packagequantity = this.currentCompany.PackageQuantity;
    this.dataend = new Date();      
    this.datastart = new Date(this.dataend.getFullYear(),0,1);               
    this.dataend = new Date(this.dataend.getFullYear(),this.dataend.getMonth(),this.dataend.getDate());          
    
    // if (this.currentCompany.CompanyType == CompanyTypeEnum.DESK && this.currentCompany?.LicenseValidFrom != null) {
    //   this.datastart = new Date(this.currentCompany?.LicenseValidFrom)
    // }
    // Se vogliamo rispettare il periodo della licenza
    //this.datastart = new Date(this.currentCompany?.LicenseValidFrom);     
    //this.dataend = new Date(this.currentCompany?.LicenseValidTo);     
    

    this.totalefattureattive=0;
    this.totalefatturepassive=0;
    this.totalefatture=0;
    this.loadinvoiceCounters();
    
  }

  getUrlPortaleFe() {
    this.sdiService.getUrlPortaleFe(GlobalService.getUsedCompany()).then((res) => {
      this.sdiResponse = res;
    }).catch((err) => {
      DialogService.Error(err.message);
    })
  }

  configureColumns() {
    this.columns = [      
      { key: "RagioneSociale", display: this.translate.instant("GENERIC_FIELDS.DENOMINATION"), styles: { flex: "0 0 40%" } },
      { key: "PartitaIva", display: this.translate.instant("GENERIC_FIELDS.VATNUMBER"), styles: { flex: "0 0 11%" } },      
      { key: "TotaleFattureAttive", display: this.translate.instant("GENERIC_LABEL.ACTIVE_INVOICE"), numberPipe: NumberColumnPipe.DECIMAL, currencyPipeCode: "EUR", styles: { flex: "0 0 11%", cellAlignment: CellAlignmentEnum.RIGHT } },
      { key: "TotaleFatturePassive", display: this.translate.instant("GENERIC_LABEL.PASSIVE_INVOICE"), numberPipe: NumberColumnPipe.DECIMAL, currencyPipeCode: "EUR", styles: { flex: "0 0 11%", cellAlignment: CellAlignmentEnum.RIGHT } },            
      { key: "TotaleFattureProforma", display: this.translate.instant("GENERIC_LABEL.TOTAL_INVOICES"), numberPipe: NumberColumnPipe.DECIMAL, currencyPipeCode: "EUR", styles: { flex: "0 0 11%", cellAlignment: CellAlignmentEnum.RIGHT } },  

    ]
  }


  exit() {    
    this.router.navigate(['/dashboard']);
  }

  async loadinvoiceCounters() {    
            
    await this.sdiService.getInvoiceStateCounters(  this.currentCompany.ID, this.datastart, this.dataend ).then(res => {      
      this.invoiceCounters = res; 
      
      this.invoiceCounters.forEach(element => {
      this.totalefattureattive += element.TotaleFattureAttive;
      this.totalefatturepassive += element.TotaleFatturePassive;
      this.totalefatture += element.TotaleFattureProforma;
      
            
      });
      
      }).catch(error => {
      DialogService.Error(error.message);
    });

    GlobalService.companyDashboardStaticObject.ActiveInvoiceCounter = this.totalefattureattive;
    GlobalService.companyDashboardStaticObject.PassiveInvoiceCounter = this.totalefatturepassive;
  }
  

  private initImportExportDTO(entityTypeName: string) {
    let importExportDTO = new ImportExportDTO();
    importExportDTO.FileType = FileTypeEnum.xlsx;
    importExportDTO.MimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    importExportDTO.EntityTypeName = entityTypeName;
    importExportDTO.Delimiter = ';';
    importExportDTO.Eol = '\r\n';
    importExportDTO.TextQualifier = '"';
    importExportDTO.ApplyFormatToLabels = false;
    importExportDTO.RemoveHeader = false;
    importExportDTO.NumberOfColumns = 5;
    importExportDTO.AreLabelsWithoutFormat = true;
    importExportDTO.IsHeaderMissing = false;
    importExportDTO.AutofitColumns = true;    

    return importExportDTO;
  }
  

  customExportFunction(importExportDTO: ImportExportDTO): Function {
    return () => {      
      let additionalParams = { 'listInvoiceCounters': this.invoiceCounters};      
            
      this.importExportService.exportFromIBaseEntity(importExportDTO, additionalParams)
        .then((res) => {
          UtilityService.downLoadFile(res, importExportDTO.MimeType, `${("InvoiceCounters_") + new Date().toLocaleDateString('IT')}.${'xlsx'}`);
        }).catch((err) => {
          DialogService.Error(err.message);
        });
    };
  }


}
